import React from "react";
import { Typography, Box } from "@mui/material";

const ConfirmElements = ({ item, label }) => {
  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="body2">{item}</Typography>
      <Typography variant="caption" sx={{ mt: "-7px" }}>
        {label}
      </Typography>
    </Box>
  );
};

export default ConfirmElements;
